import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=d8d2bf5a&scoped=true&lang=pug&"
import script from "./SessionList.vue?vue&type=script&lang=js&"
export * from "./SessionList.vue?vue&type=script&lang=js&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=d8d2bf5a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d2bf5a",
  null
  
)

export default component.exports